/*
 *   File : loader.js
 *   Author : https://evoqins.com
 *   Description : Loader component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React from 'react';

const Loader = (props) => {
    return (
        <div className={`${props.className} d-flex align-items-center justify-content-center`}>
            <img src={require("../../Assets/Image/loader.gif")}
                draggable={false}
                width={props.width ? props.width : 80}
                height={props.height ? props.height : 80}
                alt='loader'
                className='text-center' />
        </div>
    )
}

export default Loader;
